/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema, unknown } from '../schema';
import { Data22, data22Schema } from './data22';
import { Links, linksSchema } from './links';

export interface AC121Retrieveastatement {
  data: Data22;
  links: Links;
  meta?: unknown;
}

export const aC121RetrieveastatementSchema: Schema<AC121Retrieveastatement> = object(
  {
    data: ['Data', lazy(() => data22Schema)],
    links: ['Links', lazy(() => linksSchema)],
    meta: ['Meta', unknown()],
  }
);
